import React from 'react';
import { useAuth } from '@clerk/clerk-react';
import LoginPage from './LoginPage';

export default function AuthGuard({ children }) {
  const { isLoaded, isSignedIn } = useAuth();

  // Development mode bypass (for faster development)
  const devMode = process.env.REACT_APP_DEV_MODE === 'true';
  if (devMode) {
    console.log('⚠️ Development mode: Authentication bypassed');
    return <>{children}</>;
  }

  // Show loading state while Clerk is initializing
  if (!isLoaded) {
    return (
      <div style={{
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)'
      }}>
        <div style={{
          textAlign: 'center',
          color: 'white'
        }}>
          <div style={{
            width: 50,
            height: 50,
            border: '3px solid rgba(255,255,255,0.1)',
            borderTop: '3px solid #6366f1',
            borderRadius: '50%',
            margin: '0 auto 20px',
            animation: 'spin 1s linear infinite'
          }}></div>
          <p style={{ fontSize: 16, color: 'rgba(255,255,255,0.7)' }}>
            Loading...
          </p>
          <style>{`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}</style>
        </div>
      </div>
    );
  }

  // Show login page if not signed in
  if (!isSignedIn) {
    return <LoginPage />;
  }

  // User is authenticated, show the app
  return <>{children}</>;
}
